// extracted by mini-css-extract-plugin
export var defaultWrapper = "_jd-3";
export var downloadButton = "_jd-4";
export var fileContainer = "_jd-9 _jd-7";
export var fileContainerBase = "_jd-7";
export var fileContainerBaseSm = "_jd-a _jd-7";
export var fileContainerFixedHeight = "_jd-8 _jd-7";
export var fileContainerFixedHeightSm = "_jd-c _jd-a _jd-7";
export var fileContainerSm = "_jd-b _jd-a _jd-7";
export var fileInfo = "_jd-5";
export var fileInfoWidthRestricted = "_jd-6";
export var fileType = "_jd-1";
export var fileTypeName = "_jd-2";
export var fileTypeSm = "_jd-d _jd-1";
export var image = "_jd-0";
export var link = "_jd-f";
export var overflowEllipsis = "_jd-e";